import version from '../version/version.json';
import { getIsMobile } from './helpers';

export const getAppParamValue = (mobileAppVersion: string | null): string => {
  const appVersion = getIsMobile() ? mobileAppVersion : version.version;
  return `WebManager/${appVersion}`;
};
